<template>
  <!-- 材料统计 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :md="6" :sm="12">
            <a-form-item label="项目编码">
              <a-input v-model="query.establishmentNo" placeholder="请选择项目编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="项目名称">
              <a-input v-model="query.establishmentName" placeholder="请选择项目名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="材料编号">
              <a-input v-model="query.materialsNo" placeholder="请输入材料编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="材料名称">
              <a-input v-model="query.materialsName" placeholder="请输入材料名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="10" :sm="20" style="display: flex">
            <a-form-item>
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <!-- <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateHandle()">新增</a-button> -->
              <!-- <a-button type="primary" style="margin-left: 12px" @click="leadIn()">导入</a-button> -->
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table
      size="middle"
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="approveStatus" slot-scope="text, record">
        <a-tag v-if="record.approveStatus === 0" color="rgb(255, 99, 71)">待审批</a-tag>
        <a-tag v-if="record.approveStatus === 1" color="rgb(50, 205, 50)">审批通过 </a-tag>
        <a-tag v-if="record.approveStatus === 2" color="rgb(255, 99, 71)">审批不通过</a-tag>
        <!-- <a-tag v-if="record.approveStatus === 0" color="#F0F8FF">待审批</a-tag>
        <a-tag v-if="record.approveStatus === 1" color="#00FF7F">审批通过</a-tag>
        <a-tag v-if="record.approveStatus === 2" color="#FF6600">审批不通过</a-tag> -->
      </span>
    </a-table>
    <!-- 新增 修改 的弹框 -->

    <a-modal
      title="新增"
      style="top: 20px"
      :width="800"
      :visible="addOrUpdateVisible"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-row>
          <a-col :span="8">
            <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="项目名称">
              <a-select
                placeholder="选择项目名称"
                default-value
                v-decorator="['establishmentNo', { rules: [{ required: true, message: '选择项目名称' }] }]"
              >
                <a-select-option
                  v-for="ite in userlists"
                  :key="ite.key.establishmentNo"
                  :value="ite.key.establishmentNo"
                >
                  {{ ite.key.establishmentName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="材料编码">
              <a-input
                placeholder="材料编码"
                v-decorator="['materialsNo', { rules: [{ required: true, message: '请输入材料编码' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8"> </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="材料类型">
              <a-select
                placeholder="选择材料类型"
                default-value
                @change="handleChan"
                v-decorator="['materialsName', { rules: [{ required: true, message: '请选择材料类型' }] }]"
              >
                <a-select-option v-for="ite in zoneTreeData" :key="ite.id" :value="ite.id">
                  {{ ite.materialsName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="材料名称">
              <a-select placeholder="选择材料名称" default-value @change="handleChans">
                <a-select-option v-for="ite in zoneData" :key="ite.id" :value="ite.id">
                  {{ ite.materialsName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="材料规格">
              <a-select placeholder="选择项目规格" default-value>
                <a-select-option v-for="ite in zoneDatat" :key="ite.id" :value="ite.id">
                  {{ ite.materialsName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="单位">
              <a-select
                placeholder="选择计量单位"
                default-value
                v-decorator="['unit', { rules: [{ required: true, message: '请选择单位' }] }]"
              >
                <a-select-option v-for="item in MateRial" :key="item.dictValue">{{ item.dictValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="负责人">
              <a-input
                placeholder="请输入负责人"
                v-decorator="['principalUserName', { rules: [{ required: true, message: '请输入负责人' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="数量">
              <a-input
                placeholder="数量"
                v-decorator="['quantity', { rules: [{ required: true, message: '请输入材料数量' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!-- 导入 -->
    <a-modal
      title="导入数据"
      style="top: 20px"
      :width="800"
      :destroyOnClose="true"
      :visible="visible"
      @ok="handleOks"
      @cancel="handleCancel"
    >
      <p>导出模板</p>
      <a-button type="primary" @click="exportHandle()" :loading="exportLoading">导出</a-button>
      <br />
      <br />
      <br />
      <a-form-model
        ref="engineeringProjectEstablishment"
        :model="engineeringProjectEstablishment"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="选择负责人" prop="principalUserId">
          <a-select placeholder="选择一个负责人" v-model="engineeringProjectEstablishment.principalUserId">
            <a-select-option v-for="item in userlist" :key="item.key.principalId" :value="item.key.principalId">
              {{ item.key.principal }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="选择项目名称" prop="establishmentNo">
          <a-select placeholder="选择一个项目" v-model="engineeringProjectEstablishment.establishmentNo">
            <a-select-option v-for="ite in userlists" :key="ite.key.establishmentNo" :value="ite.key.establishmentNo">
              {{ ite.key.establishmentName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <p>导入数据</p>
      <a-upload-dragger :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">单击或拖动文件到此区域上传支持单个或批量上传</p>
        <p class="ant-upload-hint">支持扩展名：.rar .zip .doc .docx .pdF .jpg...</p>
      </a-upload-dragger>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
const columns = [
  {
    title: '项目编码',
    dataIndex: 'establishmentNo',
  },
  {
    title: '项目名称',
    dataIndex: 'establishmentName',
  },
  {
    title: '材料编码',
    dataIndex: 'materialsNo',
  },
  {
    title: '材料名称 ',
    dataIndex: 'materialsName',
  },
  {
    title: '材料规格',
    dataIndex: 'materialType',
  },
  {
    title: '数量',
    dataIndex: 'quantity',
  },
  {
    title: '单位',
    dataIndex: 'unit',
  },
  {
    title: '审批状态',
    dataIndex: 'approveStatus',
    scopedSlots: { customRender: 'approveStatus' },
  },
  {
    title: '负责人 ',
    dataIndex: 'principalUserName',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
  },
]

export default {
  components: {},
  mixins: [mixinViewModule],
  name: 'MaterialStatistics',
  data() {
    return {
      queryUrl: '/pipe-network/engineering_project_materialss/page', //列表请求数据接口
      addOrUpdateUrl: '/pipe-network/engineering_project_materialss', //新增
      queryOneUrl: '', //查询单条地址
      exportDataUrl: 'pipe-network/engineering_project_materialss/template/download', // 导出数据url
      exportFileName: '材料统计.xlsx', // 导出文件名称
      staffTreeData: [], // 分区数据选项
      bookTreeData: [], // 分区数据选项
      userlist: [],
      userlists: [],
      MateRial: [],
      zoneData: [],
      zoneDatas: [],
      zoneDatat: [],
      zoneTreeData: [],
      engineeringProjectEstablishment: {
        principalUserId: '',
        establishmentNo: '',
      },
      query: {
        materialsNo: '',
        materialsName: '',
        establishmentName: '',
        establishmentNo: '',
      }, // 查询参数
      file: '',
      rules: {
        principalUserId: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        establishmentNo: [{ required: true, message: '请选择项目名称', trigger: 'change' }],
      },
      addOrUpdateVisible: false, // 新增修改是否可见
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }), //新增 修改
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      visible: false,
      fileList: [],
      erid: '',
      queryZoneDateUrl: '/pipe-network/water_materialss',
      waterMaterialLinkageQuery: {
        id: '',
        type: 1,
      },
    }
  },
  created() {
    this.queryList()
    this.Responsibleinterface()
    this.Getallitems()
    this.getTaskList()
    this.getZoneData()
  },
  methods: {
    handleChan(value) {
      this.zoneData = []
      this.erid = value
      this.waterMaterialLinkageQuery = {
        id: this.erid,
        type: 3,
      }
      let params = {
        id: this.waterMaterialLinkageQuery.id,
        type: this.waterMaterialLinkageQuery.type,
      }
      this.$http.get(this.queryZoneDateUrl, { params }).then(({ data }) => {
        this.zoneData = data
      })
    },
    handleChans(value) {
      this.waterMaterialLinkageQuery = {
        id: this.erid,
        type: 2,
      }
      let params = {
        id: this.waterMaterialLinkageQuery.id,
        type: this.waterMaterialLinkageQuery.type,
      }
      this.$http.get(this.queryZoneDateUrl, { params }).then(({ data }) => {
        this.zoneDatat = data
      })
    },
    // handleChant(value) {
    //   this.waterMaterialLinkageQuery = {
    //     id: value,
    //     type: 2,
    //   }
    //   let params = {
    //     id: this.waterMaterialLinkageQuery.id,
    //     type: this.waterMaterialLinkageQuery.type,
    //   }
    //   this.$http.get(this.queryZoneDateUrl, { params }).then(({ data }) => {
    //     this.zoneDatas = data

    //     console.log(this.zoneData, 'hhhh')
    //   })
    // },
    // 库房名称下拉选择 联动树
    getZoneData(i) {
      let params = {
        id: this.waterMaterialLinkageQuery.id,
        type: this.waterMaterialLinkageQuery.type,
      }
      this.$http.get(this.queryZoneDateUrl, { params }).then(({ data }) => {
        this.zoneTreeData = data
        console.log(this.zoneTreeData, 'hhhh')
      })
    },
    //字典
    getTaskList() {
      const params = {
        dictCode: 'MATERIAL-UNIT-OF-MEASURE',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        
        this.MateRial = data
        console.log(data, '字典')
      })
    },
    //获取所有项目的接口
    Getallitems() {
      this.$http.get('/pipe-network/engineering_project_materialss/projects').then(({ data }) => {
        let list = []
        data.map((ite) => {
          console.log(ite)
          list.push({
            key: ite,
          })
        })
        this.userlists = list
      })
    },
    //负责人下拉框
    Responsibleinterface() {
      this.$http.get('/pipe-network/engineering_project_establishments/principals').then(({ data }) => {
        let list = []
        data.map((item) => {
          console.log(item)
          list.push({
            title: item.real_name,
            key: item,
            name: item.real_name,
          })
        })
        this.userlist = list
      })
    },
    // 根据id 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.RightData = []
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.addOrUpdateForm.setFieldsValue(data)
          })
          .catch(() => {})
      }
    },
    // 取消
    handleCancel() {
      this.visible = false
      // this.$refs.engineeringProjectEstablishment.resetFields()
    },
    // 导入
    leadIn() {
      this.visible = true
    },
    beforeUpload(file) {
      this.fileList = [file]
      return false
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    //确定文件上传
    handleOks() {
      this.$refs.engineeringProjectEstablishment.validate((valid) => {
        if (valid) {
          if (this.fileList.length !== 0) {
            const { fileList } = this
            const formData = new FormData()
            fileList.forEach((file) => {
              formData.append('file', file)
              formData.append('principalUserId', this.engineeringProjectEstablishment.principalUserId)
              formData.append('establishmentNo', this.engineeringProjectEstablishment.establishmentNo)
            })
            this.$http({
              url: '/pipe-network/engineering_project_materialss/import',
              method: 'post',
              processData: false,
              data: formData,
              success: () => {
                this.fileList = []
                this.uploading = false
              },
              error: () => {
                this.uploading = false
                console.log('upload failed.')
              },
            })
            this.visible = false
            this.$message.success('操作成功！')
            // this.$refs.engineeringProjectEstablishment.resetFields()
            this.queryList()
          } else {
            this.$message.error('请选择文件上传！')
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //文件上传
    handleChange(info) {
      const status = info.file.status
      if (status !== 'uploading') {
        this.file = info.fileList[0].name
        console.log(this.file, 'ffff')
        console.log(info.file, info.fileList[0].name, 'hhhhhh')
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
